var _circle, _rect, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDriverReport(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 51,
    viewBox: "0 0 51 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 25.2891,
    cy: 25.5,
    r: 25,
    fill: "#9C4900"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_428_67263",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 10,
    y: 10,
    width: 31,
    height: 31
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 10.6562,
    y: 10.7969,
    width: 30,
    height: 30,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_428_67263)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M37.3797 28.1992C36.8843 30.6193 35.6525 32.8269 33.8533 34.5196C32.0541 36.2122 29.7755 37.307 27.3297 37.6539V35.2305C29.136 34.9086 30.8119 34.0749 32.1583 32.8285C33.5047 31.5821 34.4649 29.9753 34.925 28.1992H37.3797ZM16.3844 28.1992C16.839 29.9551 17.7827 31.5458 19.1056 32.7866C20.4286 34.0274 22.0765 34.8673 23.8578 35.2086V37.6367C21.436 37.2678 19.1856 36.165 17.41 34.4772C15.6345 32.7894 14.4192 30.5977 13.9281 28.1977H16.3859L16.3844 28.1992ZM32.8328 24.6055V27.0008H29.2391C28.6351 27.0003 28.0533 27.2283 27.6105 27.6389C27.1676 28.0496 26.8965 28.6126 26.8516 29.2148V29.3945V32.9883H24.4594V29.3945C24.4598 28.7898 24.2312 28.2074 23.8195 27.7645C23.4079 27.3215 22.8437 27.0509 22.2406 27.007H22.0609H18.4672V24.6086L32.8328 24.6055ZM25.6562 13.8398C28.621 13.842 31.4794 14.9448 33.6774 16.9343C35.8754 18.9239 37.2566 21.6587 37.5531 24.6086H35.1531C34.8618 22.2954 33.7363 20.168 31.9877 18.6258C30.2391 17.0836 27.9878 16.2326 25.6562 16.2326C23.3247 16.2326 21.0734 17.0836 19.3248 18.6258C17.5762 20.168 16.4507 22.2954 16.1594 24.6086H13.75C14.0471 21.6572 15.4296 18.9214 17.6295 16.9316C19.8295 14.9419 22.69 13.84 25.6562 13.8398Z",
    fill: "#F6EFE9"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDriverReport);
export default __webpack_public_path__ + "static/media/DriverReport.c063935ede93fd20dc3eb0dfbb65c748.svg";
export { ForwardRef as ReactComponent };